// Atril del jugador: contenedor ordenado de fichas en mano.
export class Rack {
  constructor(tiles = []) {
    this.tiles = tiles; // array de instancias de ficha
  }

  get size() {
    return this.tiles.length;
  }

  isEmpty() {
    return this.tiles.length === 0;
  }

  /** Fichas "normales" (no comodines) que quedan en mano. */
  regularCount() {
    return this.tiles.reduce((n, t) => n + (t.type === 'wildcard' ? 0 : 1), 0);
  }

  /** Se considera "vacía" para GANAR si no quedan fichas normales (solo comodines o nada). */
  isEffectivelyEmpty() {
    return this.regularCount() === 0;
  }

  add(tile) {
    this.tiles.push(tile);
  }

  addMany(tiles) {
    for (const t of tiles) this.tiles.push(t);
  }

  /** Extrae una ficha por instanceId. Devuelve la ficha o null. */
  remove(instanceId) {
    const idx = this.tiles.findIndex((t) => t.instanceId === instanceId);
    if (idx === -1) return null;
    return this.tiles.splice(idx, 1)[0];
  }

  find(instanceId) {
    return this.tiles.find((t) => t.instanceId === instanceId) || null;
  }

  has(instanceId) {
    return this.tiles.some((t) => t.instanceId === instanceId);
  }

  /** Suma de valores de las fichas restantes (penalización final). */
  remainingValue() {
    return this.tiles.reduce((sum, t) => sum + (t.value || 0), 0);
  }

  toJSON() {
    return this.tiles;
  }
}
